<template>
  <CustomDeleteDialog
    dialogTitle="حذف درس از دوره"
    dialogId="delete-lesson-from-course-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="deleteLessonFromCourse"
  >
    <BCol cols="12" v-if="selectedLessonDetails">
      <p>
        آیا از حذف درس
        <span class="font-weight-bolder">
          {{ selectedLessonDetails.title }}
        </span>
        از دوره
        <span class="font-weight-bolder">
          {{ selectedLessonDetails.course.title }}
        </span>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    selectedLessonDetails: {
      type: [Object],
      required: false,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async deleteLessonFromCourse() {
      try {
        this.isOkButtonDisabled = true;
        const _this = this;
        const deleteLessonFromCourse = new DeleteLessonFromCourse(_this);
        deleteLessonFromCourse.setRequestParam({
          lessonId: _this.selectedLessonDetails.lessonId,
        });
        await deleteLessonFromCourse.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "درس با موفقیت حذف شد",
                icon: "EditIcon",
                variant: "success",
              },
            });
            _this.$emit("refetch");
            _this.$bvModal.hide("delete-lesson-from-course-dialog");
          } else {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: `توجه`,
                icon: "",
                variant: "danger",
                text: `مشکلی پیش آمد`,
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomDeleteDialog,
    BCol,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { BCol } from "bootstrap-vue";
import { DeleteLessonFromCourse } from "@/libs/Api/Lesson";
</script>
